import { RouteObject } from 'react-router-dom'

import { default as Users } from '.'
import { PageLayout } from '../../../common/app'

/**
 * Routes for the Manage Users page - the React replacement for the AngularJS
 * `Settings.CompanyEdit` page. Scoped to the active venue, so the route has no
 * `:id` segment.
 *
 * `htmlTitleOnly` suppresses the standard in-page header (which otherwise shows
 * the reports date filter that has no meaning here); the page renders its own
 * content.
 */
export const usersRoutes: RouteObject[] = [
  {
    path: '/settings/users',
    element: (
      <PageLayout title="Manage Users" htmlTitleOnly alignMainContent="center">
        <Users.ManageUsers.Component />
      </PageLayout>
    ),
    loader: Users.ManageUsers.Loader,
  },
]
